import { useState, useReducer } from "react";
import { useSelector, useDispatch } from "react-redux";
import "./shippings.css";
import axios from "axios";
import { useSnackbar } from "notistack";
import * as Action from "../../../../../store/redux/terminal_reducer.js";

import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";

export function AddShipping({ salesPayload, setPaymentMethod }) {
  const [cashCollected, setCashCollected] = useState(0);
  const [errors, setErrors] = useState({});
  const dispatch = useDispatch();
  const existingShipping = useSelector(
    (state) => state.terminalActions?.inventoryPOS?.shipping,
  );

  const {
    cart,
    updatesPayload,
    discount,
    customerName,
    customerId,
    setLoading,
    setOpenModal,
    secondaryFunction,
    setAlert,
    subTotal,
    total,
    tax,
  } = salesPayload;

  const shippingReducer = (state, action) => {
    return {
      ...state,
      ...action,
    };
  };

  const [shippingData, setShippingData] = useReducer(shippingReducer, {
    shippingId:
      existingShipping?.shippingId ||
      window.crypto?.randomUUID?.() ||
      `SHIP-${Date.now()}`,
    firstName: existingShipping?.recipient?.firstName || "",
    lastName: existingShipping?.recipient?.lastName || "",
    company: existingShipping?.recipient?.company || "",
    phone: existingShipping?.recipient?.phone || "",
    email: existingShipping?.recipient?.email || "",

    street: existingShipping?.address?.street || "",
    apartment: existingShipping?.address?.apartment || "",
    city: existingShipping?.address?.city || "",
    state: existingShipping?.address?.state || "",
    postalCode: existingShipping?.address?.postalCode || "",
    country: existingShipping?.address?.country || "Nigeria",
    landmark: existingShipping?.address?.landmark || "",

    deliveryMethod: existingShipping?.delivery?.method || "",
    carrier: existingShipping?.delivery?.carrier || "",
    trackingNumber: existingShipping?.delivery?.trackingNumber || "",
    estimatedDelivery: existingShipping?.delivery?.estimatedDelivery || "",
    shippingFee: existingShipping?.delivery?.shippingFee ?? 0,
    currency: existingShipping?.delivery?.currency || "",
    deliveryStatus: existingShipping?.delivery?.status || "",

    weight: existingShipping?.package?.weight ?? 0,
    weightUnit: existingShipping?.package?.weightUnit || "",
    length: existingShipping?.package?.length ?? 0,
    width: existingShipping?.package?.width ?? 0,
    height: existingShipping?.package?.height ?? 0,
    dimensionUnit: existingShipping?.package?.dimensionUnit || "",
    itemsCount: existingShipping?.package?.itemsCount ?? 0,

    payer: existingShipping?.billing?.payer || "",
    paymentStatus: existingShipping?.billing?.paymentStatus || "",
    paymentMethod: existingShipping?.billing?.paymentMethod || "",

    notes: existingShipping?.notes || "",
  });

  const payloadShipping = {
    state: true,
    shippingId: shippingData?.shippingId,

    recipient: {
      firstName: shippingData?.firstName,
      lastName: shippingData?.lastName,
      company: shippingData?.company,
      phone: shippingData?.phone,
      email: shippingData?.email,
    },

    address: {
      street: shippingData?.street,
      apartment: shippingData?.apartment,
      city: shippingData?.city,
      state: shippingData?.state,
      postalCode: shippingData?.postalCode,
      country: shippingData?.country,
      landmark: shippingData?.landmark,
    },

    delivery: {
      method: shippingData?.deliveryMethod,
      carrier: shippingData?.carrier,
      trackingNumber: shippingData?.trackingNumber,
      estimatedDelivery: shippingData?.estimatedDelivery,
      shippingFee: shippingData?.shippingFee,
      currency: shippingData?.currency,
      status: shippingData?.deliveryStatus,
    },

    package: {
      weight: shippingData?.weight,
      weightUnit: shippingData?.weightUnit,
      length: shippingData?.length,
      width: shippingData?.width,
      height: shippingData?.height,
      dimensionUnit: shippingData?.dimensionUnit,
      itemsCount: shippingData?.itemsCount,
    },

    billing: {
      payer: shippingData?.payer,
      paymentStatus: shippingData?.paymentStatus,
      paymentMethod: shippingData?.paymentMethod,
    },

    notes: shippingData?.notes,
    createdAt: existingShipping?.createdAt || new Date().toISOString(),
    updatedAt: new Date().toISOString(),
  };

  const validateForm = () => {
    let newErrors = {};

    if (!shippingData.firstName.trim())
      newErrors.firstName = "First name is required";
    if (!shippingData.lastName.trim())
      newErrors.lastName = "Last name is required";
    if (!shippingData.phone.trim())
      newErrors.phone = "Phone number is required";
    if (!shippingData.street.trim())
      newErrors.street = "Street address is required";
    if (!shippingData.city.trim()) newErrors.city = "City is required";
    if (!shippingData.state.trim()) newErrors.state = "State is required";
    if (!shippingData.country.trim()) newErrors.country = "Country is required";
    if (!shippingData.deliveryMethod.trim())
      newErrors.deliveryMethod = "Delivery method is required";
    if (
      shippingData.shippingFee === "" ||
      shippingData.shippingFee === null ||
      !Number.isFinite(Number(shippingData.shippingFee)) ||
      Number(shippingData.shippingFee) < 0
    ) {
      newErrors.shippingFee = "Shipping fee is required";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleInputChange = (field, value) => {
    setShippingData({ [field]: value });
    if (errors[field]) {
      setErrors((prev) => ({ ...prev, [field]: null }));
    }
  };

  function handleShipping() {
    if (cart.length === 0) {
      setAlert({
        message: `Please add items to the cart before proceeding with shipping.`,
        type: "error",
      });
      return;
    }

    if (!validateForm()) {
      setAlert({
        message: `Please fill in all required shipping fields.`,
        type: "error",
      });
      return;
    }

    setAlert({
      message: `Shipping information has been added successfully!`,
      type: "info",
    });
    dispatch(Action.addShippingDispatch({ payloadShipping }));
    setOpenModal(false);
  }

  return (
    <div className="shippingWrapper">
      <div
        id="shippingCont"
        className=" fx-cl"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="shippingHeader fx-ac fx-jb space3">
          <div className="fx-cl spacem">
            <h3 className="fs6 fw500">
              <span>{existingShipping?.state ? "Edit" : "Add"} Shipping </span>{" "}
              <span style={{ color: "var(--primary-color)" }}>Information</span>
            </h3>

            <span className="fs3">
              Save a delivery address and shipping instructions with the current
              sale. Shipping fees are not added to checkout totals
              automatically.
            </span>
          </div>

          <button
            className="btnCloseacceptRtrn fx-ac fx-jc"
            onClick={() => setOpenModal(false)}
          >
            <CloseOutlinedIcon style={{ fontSize: "3.1rem" }} />
          </button>
        </div>

        {/* ===========================
            PERSONAL INFORMATION
        ============================ */}

        <figure className="shippingfigure">
          <div className="shippingfigureTitle">Personal Information</div>

          <div className="shippingGrid">
            <div className="shippingField">
              <label>
                First name <span style={{ color: "red" }}>*</span>
              </label>
              <input
                value={shippingData.firstName}
                onChange={(event) =>
                  handleInputChange("firstName", event.target.value)
                }
                type="text"
                name="first_name"
                style={errors.firstName ? { borderColor: "red" } : {}}
              />
              {errors.firstName && (
                <span style={{ color: "red", fontSize: "1.2rem" }}>
                  {errors.firstName}
                </span>
              )}
            </div>

            <div className="shippingField">
              <label>
                Last name <span style={{ color: "red" }}>*</span>
              </label>
              <input
                value={shippingData.lastName}
                onChange={(event) =>
                  handleInputChange("lastName", event.target.value)
                }
                type="text"
                name="last_name"
                style={errors.lastName ? { borderColor: "red" } : {}}
              />
              {errors.lastName && (
                <span style={{ color: "red", fontSize: "1.2rem" }}>
                  {errors.lastName}
                </span>
              )}
            </div>

            <div className="shippingField">
              <label>Company</label>
              <input
                value={shippingData.company}
                onChange={(event) =>
                  setShippingData({ company: event.target.value })
                }
                type="text"
                name="company"
              />
            </div>

            <div className="shippingField">
              <label>
                Phone <span style={{ color: "red" }}>*</span>
              </label>
              <input
                value={shippingData.phone}
                onChange={(event) =>
                  handleInputChange("phone", event.target.value)
                }
                type="text"
                name="phone"
                style={errors.phone ? { borderColor: "red" } : {}}
              />
              {errors.phone && (
                <span style={{ color: "red", fontSize: "1.2rem" }}>
                  {errors.phone}
                </span>
              )}
            </div>

            <div className="shippingField shippingSpan2">
              <label>Email</label>
              <input
                value={shippingData.email}
                onChange={(event) =>
                  setShippingData({ email: event.target.value })
                }
                type="email"
                name="email"
              />
            </div>
          </div>
        </figure>

        {/* ===========================
                ADDRESS
        ============================ */}

        <figure className="shippingfigure">
          <div className="shippingfigureTitle">Address</div>

          <div className="shippingGrid">
            <div className="shippingField shippingSpan2">
              <label>
                Street <span style={{ color: "red" }}>*</span>
              </label>
              <input
                value={shippingData.street}
                onChange={(event) =>
                  handleInputChange("street", event.target.value)
                }
                type="text"
                name="street"
                style={errors.street ? { borderColor: "red" } : {}}
              />
              {errors.street && (
                <span style={{ color: "red", fontSize: "1.2rem" }}>
                  {errors.street}
                </span>
              )}
            </div>

            <div className="shippingField">
              <label>Apartment</label>
              <input
                value={shippingData.apartment}
                onChange={(event) =>
                  setShippingData({ apartment: event.target.value })
                }
                type="text"
                name="apartment"
              />
            </div>

            <div className="shippingField">
              <label>
                City <span style={{ color: "red" }}>*</span>
              </label>
              <input
                value={shippingData.city}
                onChange={(event) =>
                  handleInputChange("city", event.target.value)
                }
                type="text"
                name="city"
                style={errors.city ? { borderColor: "red" } : {}}
              />
              {errors.city && (
                <span style={{ color: "red", fontSize: "1.2rem" }}>
                  {errors.city}
                </span>
              )}
            </div>

            <div className="shippingField">
              <label>
                State <span style={{ color: "red" }}>*</span>
              </label>
              <input
                value={shippingData.state}
                onChange={(event) =>
                  handleInputChange("state", event.target.value)
                }
                type="text"
                name="state"
                style={errors.state ? { borderColor: "red" } : {}}
              />
              {errors.state && (
                <span style={{ color: "red", fontSize: "1.2rem" }}>
                  {errors.state}
                </span>
              )}
            </div>

            <div className="shippingField">
              <label>Postal Code</label>
              <input
                value={shippingData.postalCode}
                onChange={(event) =>
                  setShippingData({ postalCode: event.target.value })
                }
                type="text"
                name="postal_code"
              />
            </div>

            <div className="shippingField">
              <label>
                Country <span style={{ color: "red" }}>*</span>
              </label>
              <input
                value={shippingData.country}
                onChange={(event) =>
                  handleInputChange("country", event.target.value)
                }
                type="text"
                name="country"
                style={errors.country ? { borderColor: "red" } : {}}
              />
              {errors.country && (
                <span style={{ color: "red", fontSize: "1.2rem" }}>
                  {errors.country}
                </span>
              )}
            </div>

            <div className="shippingField shippingSpan2">
              <label>Landmark</label>
              <input
                value={shippingData.landmark}
                onChange={(event) =>
                  setShippingData({ landmark: event.target.value })
                }
                type="text"
                name="landmark"
              />
            </div>
          </div>
        </figure>

        {/* ===========================
              DELIVERY
        ============================ */}

        <figure className="shippingfigure">
          <div className="shippingfigureTitle">Delivery Information</div>

          <div className="shippingGrid">
            <div className="shippingField">
              <label>
                Delivery Method <span style={{ color: "red" }}>*</span>
              </label>
              <input
                value={shippingData.deliveryMethod}
                onChange={(event) =>
                  handleInputChange("deliveryMethod", event.target.value)
                }
                type="text"
                name="delivery_method"
                style={errors.deliveryMethod ? { borderColor: "red" } : {}}
              />
              {errors.deliveryMethod && (
                <span style={{ color: "red", fontSize: "1.2rem" }}>
                  {errors.deliveryMethod}
                </span>
              )}
            </div>

            <div className="shippingField">
              <label>Carrier</label>
              <input
                value={shippingData.carrier}
                onChange={(event) =>
                  setShippingData({ carrier: event.target.value })
                }
                type="text"
                name="carrier"
              />
            </div>

            <div className="shippingField shippingSpan2">
              <label>Tracking Number</label>
              <input
                value={shippingData.trackingNumber}
                onChange={(event) =>
                  setShippingData({ trackingNumber: event.target.value })
                }
                type="text"
                name="tracking_number"
              />
            </div>

            <div className="shippingField">
              <label>Estimated Delivery</label>
              <input
                value={shippingData.estimatedDelivery}
                onChange={(event) =>
                  setShippingData({ estimatedDelivery: event.target.value })
                }
                type="date"
                name="estimated_delivery"
              />
            </div>

            <div className="shippingField">
              <label>
                Shipping Fee <span style={{ color: "red" }}>*</span>
              </label>
              <input
                value={shippingData.shippingFee}
                onChange={(event) =>
                  handleInputChange("shippingFee", Number(event.target.value))
                }
                type="number"
                name="shipping_fee"
                style={errors.shippingFee ? { borderColor: "red" } : {}}
              />
              {errors.shippingFee && (
                <span style={{ color: "red", fontSize: "1.2rem" }}>
                  {errors.shippingFee}
                </span>
              )}
            </div>

            <div className="shippingField">
              <label>Currency</label>
              <input
                value={shippingData.currency}
                onChange={(event) =>
                  setShippingData({ currency: event.target.value })
                }
                type="text"
                name="currency"
              />
            </div>

            <div className="shippingField">
              <label>Status</label>
              <input
                value={shippingData.deliveryStatus}
                onChange={(event) =>
                  setShippingData({ deliveryStatus: event.target.value })
                }
                type="text"
                name="delivery_status"
              />
            </div>
          </div>
        </figure>

        {/* ===========================
              PACKAGE
        ============================ */}

        <figure className="shippingfigure ">
          <div className="shippingfigureTitle">Package Information</div>

          <div className="shippingDimension wrap fx-jb spacem">
            <div className="shippingField">
              <label>Weight</label>
              <input
                value={shippingData.weight}
                onChange={(event) =>
                  setShippingData({ weight: Number(event.target.value) })
                }
                type="number"
                name="weight"
              />
            </div>

            <div className="shippingField">
              <label>Weight Unit</label>
              <input
                value={shippingData.weightUnit}
                onChange={(event) =>
                  setShippingData({ weightUnit: event.target.value })
                }
                type="text"
                name="weight_unit"
              />
            </div>

            <div className="shippingField">
              <label>Length</label>
              <input
                value={shippingData?.length}
                onChange={(event) =>
                  setShippingData({ length: Number(event.target.value) })
                }
                type="number"
                name="length"
              />
            </div>

            <div className="shippingField">
              <label>Width</label>
              <input
                value={shippingData.width}
                onChange={(event) =>
                  setShippingData({ width: Number(event.target.value) })
                }
                type="number"
                name="width"
              />
            </div>

            <div className="shippingField">
              <label>Height</label>
              <input
                value={shippingData.height}
                onChange={(event) =>
                  setShippingData({ height: Number(event.target.value) })
                }
                type="number"
                name="height"
              />
            </div>

            <div className="shippingField">
              <label>Dimension Unit</label>
              <input
                value={shippingData.dimensionUnit}
                onChange={(event) =>
                  setShippingData({ dimensionUnit: event.target.value })
                }
                type="text"
                name="dimension_unit"
              />
            </div>

            <div className="shippingField">
              <label>Items Count</label>
              <input
                value={shippingData.itemsCount}
                onChange={(event) =>
                  setShippingData({ itemsCount: Number(event.target.value) })
                }
                type="number"
                name="items_count"
              />
            </div>
          </div>
        </figure>

        {/* ===========================
              BILLING
        ============================ */}

        <figure className="shippingfigure">
          <div className="shippingfigureTitle">Billing Information</div>

          <div className="shippingGrid">
            <div className="shippingField">
              <label>Payer</label>
              <input
                value={shippingData.payer}
                onChange={(event) =>
                  setShippingData({ payer: event.target.value })
                }
                type="text"
                name="payer"
              />
            </div>

            <div className="shippingField">
              <label>Payment Status</label>
              <input
                value={shippingData.paymentStatus}
                onChange={(event) =>
                  setShippingData({ paymentStatus: event.target.value })
                }
                type="text"
                name="payment_status"
              />
            </div>

            <div className="shippingField shippingSpan2">
              <label>Payment Method</label>
              <input
                value={shippingData.paymentMethod}
                onChange={(event) =>
                  setShippingData({ paymentMethod: event.target.value })
                }
                type="text"
                name="payment_method"
              />
            </div>
          </div>
        </figure>

        {/* ===========================
                  NOTES
        ============================ */}

        <figure className="shippingfigure">
          <div className="shippingfigureTitle">Additional Notes</div>

          <div className="shippingField">
            <label>Notes</label>
            <textarea
              className="shippingTextarea"
              value={shippingData.notes}
              onChange={(event) =>
                setShippingData({ notes: event.target.value })
              }
              name="notes"
            />
          </div>
        </figure>

        {/* ===========================
                FOOTER
        ============================ */}

        <div className="shippingFooter fx-ac fx-jb">
          <div className="shippingFooterText">
            Please review all shipping information before proceeding.
          </div>

          <div className="fx-ac space1">
            <button
              type="button"
              className="shippingSecondaryBtn"
              onClick={() => setOpenModal(false)}
            >
              Cancel
            </button>

            <button
              type="button"
              className="shippingBtn"
              onClick={handleShipping}
            >
              {existingShipping?.state ? "Update" : "Save"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
